import { useQuery } from '@tanstack/react-query';
import { listarMovimientos, type FiltrosMovimientos } from '../lib/api/movimientos';
import { qk } from './keys';

export function useMovimientos(filtros: FiltrosMovimientos = {}) {
  return useQuery({
    queryKey: [...qk.movimientos, filtros],
    queryFn: () => listarMovimientos(filtros),
  });
}
